<!--新闻详情页面-->
<template>
  <div class="newsDetailClass">
    <div>
      <nav-com activeIndex="8"></nav-com>
    </div>

    <div style="padding: 30px">
      <!-- 加载中 -->
      <div v-if="loading" style="text-align: center; padding: 50px;">
        <i class="el-icon-loading" style="font-size: 30px;"></i>
        <p>加载中...</p>
      </div>

      <!-- 内容展示 -->
      <div v-else-if="newsData.ID" class="content-container">
        <!-- 返回按钮 -->
        <div style="margin-bottom: 20px;">
          <el-button type="primary" icon="el-icon-back" @click="goBack">
            返回列表
          </el-button>
        </div>

        <!-- 标题 -->
        <div class="news-title">
          {{ newsData.TITLE }}
        </div>

        <!-- 信息栏 -->
        <div class="news-info">
          <span>
            <i class="el-icon-time"></i>
            创建时间：{{ formatDateTime(newsData.CREATETIME) }}
          </span>
          <span style="margin-left: 30px;">
            <i class="el-icon-document"></i>
            内容ID：{{ newsData.ID }}
          </span>
        </div>

        <!-- 分割线 -->
        <el-divider></el-divider>

        <!-- 内容 -->
        <div class="news-content" v-html="newsData.CONTENT"></div>
      </div>

      <!-- 未找到数据 -->
      <div v-else style="text-align: center; padding: 50px;">
        <el-empty description="未找到该内容">
          <el-button type="primary" @click="goBack">返回列表</el-button>
        </el-empty>
      </div>
    </div>
  </div>
</template>

<script>
import NavCom from "../../components/navCom/NavMainCom.vue";
export default {
  name: "NewsDetail",
  components: { NavCom },
  data() {
    return {
      loading: true,
      newsData: {
        ID: "",
        TITLE: "",
        CONTENT: "",
        CREATETIME: ""
      },
      newsId: ""
    };
  },
  created() {
    this.utilPost = this.$util.handler;
  },
  mounted() {
    // 从路由参数获取ID
    this.newsId = this.$route.query.id;
    if (this.newsId) {
      this.loadNewsDetail();
    } else {
      this.loading = false;
      this.$message.error("未提供内容ID");
    }
  },
  methods: {
    // 格式化日期时间
    formatDateTime(dateTimeStr) {
      if (!dateTimeStr) return "-";
      let str = dateTimeStr.toString().trim();
      
      if (str.includes("-") && str.includes(":")) {
        return str;
      }
      
      if (/^\d{14}$/.test(str)) {
        const year = str.substring(0, 4);
        const month = str.substring(4, 6);
        const day = str.substring(6, 8);
        const hour = str.substring(8, 10);
        const minute = str.substring(10, 12);
        const second = str.substring(12, 14);
        return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
      }
      
      if (/^\d{8}$/.test(str)) {
        const year = str.substring(0, 4);
        const month = str.substring(4, 6);
        const day = str.substring(6, 8);
        return `${year}-${month}-${day} 00:00:00`;
      }
      
      return str;
    },
    // 加载新闻详情
    loadNewsDetail() {
      this.loading = true;
      var paramData = {
        headerData: {
          op: "adminNewsGl",
          methodName: "getDetail"
        },
        busData: {
          ID: this.newsId
        }
      };
      this.utilPost.paramData = paramData;
      this.utilPost.sendPost().then(data => {
        this.loading = false;
        if (data.isSuccess) {
          this.newsData = data.content;
        } else {
          this.$message.error(data.msg || "加载失败");
        }
      }).catch(() => {
        this.loading = false;
        this.$message.error("网络请求失败");
      });
    },
    // 返回列表
    goBack() {
      this.$router.push({ path: "/newsGlIndex" });
    }
  }
};
</script>

<style lang="scss" scoped>
.newsDetailClass {
  .content-container {
    max-width: 1200px;
    margin: 0 auto;
    background: #fff;
    padding: 30px;
    border-radius: 8px;
    box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
  }

  .news-title {
    font-size: 28px;
    font-weight: bold;
    color: #303133;
    line-height: 1.5;
    margin-bottom: 20px;
    text-align: center;
  }

  .news-info {
    text-align: center;
    color: #909399;
    font-size: 14px;
    margin-bottom: 20px;
    
    i {
      margin-right: 5px;
    }
  }

  .news-content {
    font-size: 16px;
    line-height: 1.8;
    color: #606266;
    text-align: left;
    word-wrap: break-word;
    
    // 富文本内容样式
    /deep/ img {
      max-width: 100%;
      height: auto;
      display: block;
      margin: 15px auto;
    }
    
    /deep/ p {
      margin: 15px 0;
    }
    
    /deep/ h1, /deep/ h2, /deep/ h3, /deep/ h4, /deep/ h5, /deep/ h6 {
      margin: 20px 0 10px;
      font-weight: bold;
    }
    
    /deep/ ul, /deep/ ol {
      margin: 15px 0;
      padding-left: 30px;
    }
    
    /deep/ blockquote {
      border-left: 4px solid #dcdfe6;
      padding-left: 15px;
      margin: 15px 0;
      color: #909399;
    }
    
    /deep/ code {
      background-color: #f5f7fa;
      padding: 2px 8px;
      border-radius: 3px;
      font-family: 'Courier New', monospace;
    }
    
    /deep/ pre {
      background-color: #f5f7fa;
      padding: 15px;
      border-radius: 5px;
      overflow-x: auto;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/view/newsGlIndex/NewsDetail.vue